var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 114,
    viewBox: "0 0 108 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2374_104847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7418 48.8509V31.2465H76.6437C87.7398 31.0332 100.223 24.9516 97.6622 15.5626C95.1016 5.96025 83.6854 4.78662 75.0433 5.96025C63.8405 7.56065 54.8782 16.5229 53.4912 17.9099C52.2109 16.5229 43.2487 7.56065 31.9392 5.85355C23.297 4.57324 11.9876 5.85355 9.42691 15.4559C6.86628 25.0583 19.8829 31.1399 31.0856 31.1399H41.755H14.0147V47.6773C12.521 48.2108 11.0273 48.7442 9.53361 49.2777L17.2155 51.625V53.5454L14.5482 60.2671C15.4017 59.947 16.362 59.6269 17.2155 59.2002V100.811H47.6231H61.7066H91.1539V60.2671C91.5807 60.3738 92.0075 60.5872 92.3276 60.6939L91.1539 57.7065V57.4931V51.4116L95.5284 50.1312H95.6351L97.5555 49.4911C97.0221 49.2777 96.3819 49.0643 95.7418 48.8509ZM88.5933 17.4831C88.5933 17.5898 81.1248 23.4579 64.9074 21.9642C64.9074 21.9642 75.47 13.5355 88.5933 17.4831ZM18.6025 17.4831C31.7258 13.4288 42.2884 21.9642 42.2884 21.9642C26.0711 23.4579 18.6025 17.5898 18.6025 17.4831Z",
    fill: "#FDF9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7418 48.8509V31.2465H76.6437C87.7398 31.0332 100.223 24.9516 97.6622 15.5626C95.1016 5.96025 83.6854 4.78662 75.0433 5.96025C63.8405 7.56065 54.8782 16.5229 53.4912 17.9099C52.2109 16.5229 43.2487 7.56065 31.9392 5.85355C23.297 4.57324 11.9876 5.85355 9.42691 15.4559C6.86628 25.0583 19.8829 31.1399 31.0856 31.1399H41.755H14.0147V47.6773C12.521 48.2108 11.0273 48.7442 9.53361 49.2777L17.2155 51.625V53.5454L14.5482 60.2671C15.4017 59.947 16.362 59.6269 17.2155 59.2002V100.811H47.6231H61.7066H91.1539V60.2671C91.5807 60.3738 92.0075 60.5872 92.3276 60.6939L91.1539 57.7065V57.4931V51.4116L95.5284 50.1312H95.6351L97.5555 49.4911C97.0221 49.2777 96.3819 49.0643 95.7418 48.8509ZM88.5933 17.4831C88.5933 17.5898 81.1248 23.4579 64.9074 21.9642C64.9074 21.9642 75.47 13.5355 88.5933 17.4831ZM18.6025 17.4831C31.7258 13.4288 42.2884 21.9642 42.2884 21.9642C26.0711 23.4579 18.6025 17.5898 18.6025 17.4831Z",
    stroke: "#FEFBF1",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.5342 30.7012H13.8072V49.5859H95.4275V30.7012H95.5342Z",
    fill: "#FFA500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0531 47.7722H17.008V100.265H91.0531V47.7722Z",
    fill: "#FFA500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8384 5.41496C23.1962 4.13464 11.8867 5.41496 9.32608 15.0173C6.76545 24.6197 19.782 30.7013 30.9848 30.7013H53.6038V17.578C53.6038 17.578 44.0014 7.22874 31.8384 5.41496ZM18.395 16.9378C31.5183 12.8835 42.0809 21.4189 42.0809 21.4189C25.8635 22.9126 18.395 17.0445 18.395 16.9378Z",
    fill: "#4200FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4546 15.0173C94.8939 5.41495 83.4778 4.24132 74.8356 5.41495C62.6726 7.12204 53.1769 17.578 53.1769 17.578V30.5946H75.6892C87.1053 30.7012 100.122 24.6197 97.4546 15.0173ZM64.6998 21.4189C64.6998 21.4189 75.1557 12.9902 88.3857 16.9378C88.3857 17.0445 80.9171 22.9126 64.6998 21.4189Z",
    fill: "#4200FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0531 47.7722H17.008V56.9478H91.0531V47.7722Z",
    fill: "#DD9522"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6707 33.582C54.6707 33.582 37.0664 51.2931 14.3407 59.6151L17.7549 51.1864L9.32611 48.6257C36.2128 40.3037 49.6562 22.5926 49.6562 22.5926L54.6707 33.582Z",
    fill: "#4200FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6163 33.2619C50.6163 33.2619 68.8609 51.5065 92.2267 60.2553L88.8125 51.5065L97.4547 48.9458C69.7144 40.3037 55.8443 22.0591 55.8443 22.0591L50.6163 33.2619Z",
    fill: "#4200FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6058 33.0485H47.5223V100.265H61.6058V33.0485Z",
    fill: "#4200FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2374_104847",
    x: 0.0875244,
    y: 0.438599,
    width: 106.925,
    height: 113.372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2374_104847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2374_104847",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/Gift.65849848.svg";
export { ForwardRef as ReactComponent };